module.exports = __webpack_public_path__ + "static/media/solution-img5.8eb95d51.png";